import { ReactNode } from 'react'
import { Body, BodyWrapper } from './styles';

export interface CentralAreaProps {
  isSuperAdmin?: boolean;
  isOpen?: boolean;
  isFormPage?: boolean;
  sidebarToggleHandler?: React.Dispatch<React.SetStateAction<boolean>>
  children?: ReactNode | ReactNode[];
}

const CentralArea = ({
  isOpen = true,
  isFormPage = false,
  children,
  sidebarToggleHandler,
  isSuperAdmin,
  ...props
}: CentralAreaProps) => {
  return (
    <BodyWrapper
      {...props}
      isSideOpen={isOpen}
      isFormPage={isFormPage}
      onClick={() => {
        if (sidebarToggleHandler !== undefined && !isSuperAdmin) {
          sidebarToggleHandler(false)
        }
      }}
    >
      <div>
        <Body>{children}</Body>
      </div>
    </BodyWrapper>
  );
};

export default CentralArea
